module.exports = __webpack_public_path__ + "img/banner-company-overview.df00cdc5.png";